import * as easyPeasy from "easy-peasy";
import { Model, Property } from "./decorators";
import { ToStoreType} from "./types";

export const modelSym:unique symbol = Symbol('modelSym')

export abstract class ModelBasePure {

    //hidden symbol prop to discriminate models from other types
    private [modelSym]:any

    static get obj() {
        return {} as any
    }
}

@Model
export abstract class ModelBase extends ModelBasePure{

    @Property
    private _isHoldingChildren: boolean = false
}



type getStoreState<StoreModel extends object> = () => easyPeasy.State<ToStoreType<StoreModel>>// & { [key: string]: any }
type getStoreActions<StoreModel extends object> = () => easyPeasy.Actions<ToStoreType<StoreModel>>// & { [key: string]: any }

interface createTypedHooksReturn<Model extends object> {
    useStoreState: <Result>(
        mapState: (state: easyPeasy.State<ToStoreType<Model>>) => Result,
        dependencies?: any[],
    ) => Result;
}

type getStoreStateClone<StoreModel extends object> = createTypedHooksReturn<StoreModel>['useStoreState']


export abstract class ModelBasePureTyped<StoreModel extends object> extends ModelBasePure {

    protected getStateClone: () => this = undefined as unknown as () => this
    protected getStoreStateClone: getStoreStateClone<StoreModel> = undefined as unknown as getStoreStateClone<StoreModel>

    protected getStoreActions: getStoreActions<StoreModel> = undefined as unknown as getStoreActions<StoreModel>
    protected getStoreState: getStoreState<StoreModel> = undefined as unknown as getStoreState<StoreModel>

}

export abstract class ModelBaseTyped<StoreModel extends object> extends ModelBase {

    protected getStateClone: () => this = undefined as unknown as () => this
    protected getStoreStateClone: getStoreStateClone<StoreModel> = undefined as unknown as getStoreStateClone<StoreModel>

    protected getStoreActions: getStoreActions<StoreModel> = undefined as unknown as getStoreActions<StoreModel>
    protected getStoreState: getStoreState<StoreModel> = undefined as unknown as getStoreState<StoreModel>

}
